var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.centerDialogVisible
        ? _c(
            "el-dialog",
            {
              staticClass: "dialog",
              attrs: {
                title: "新增注销账户",
                visible: _vm.centerDialogVisible,
                width: "800px",
                center: "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.centerDialogVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "LogOutadd" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "ruleForm",
                      staticClass: "demo-ruleForm",
                      attrs: {
                        model: _vm.ruleForm,
                        rules: _vm.rules,
                        "label-width": "110px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "客户电话", prop: "mobile" } },
                        [
                          _c(
                            "div",
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入客户电话",
                                  clearable: "",
                                },
                                on: { blur: _vm.getmemberinfo },
                                model: {
                                  value: _vm.ruleForm.mobile,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "mobile", $$v)
                                  },
                                  expression: "ruleForm.mobile",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm.info
                        ? _c(
                            "div",
                            { staticStyle: { "margin-bottom": "20px" } },
                            [
                              _vm._v(
                                " 用户所在仓：" +
                                  _vm._s(_vm.info.logistics_name) +
                                  " 下单总金额：" +
                                  _vm._s(_vm.info.order_amt) +
                                  " 元 售后总金额：" +
                                  _vm._s(_vm.info.refund_amt) +
                                  "元 最后一次下单时间：" +
                                  _vm._s(_vm.info.last_order_time) +
                                  " "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        { attrs: { label: "注销原因", prop: "reason" } },
                        [
                          _c(
                            "div",
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  maxlength: "200",
                                  placeholder: "请输入注销原因",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.ruleForm.reason,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "reason", $$v)
                                  },
                                  expression: "ruleForm.reason",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "注销证明：（请上传用户要求注销的证明）",
                            prop: "pic",
                          },
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.loadingImage,
                                  expression: "loadingImage",
                                },
                              ],
                              class: { hide: _vm.pic.length == 10 },
                              attrs: {
                                "element-loading-text": "正在上传...",
                                action: "#",
                                "on-preview": _vm.handlePictureCardPreview,
                                "file-list": _vm.pic,
                                "list-type": "picture-card",
                                "http-request": (file) => {
                                  return _vm.uploadFile(file, "pic")
                                },
                                "before-remove": (file, fileList) => {
                                  return _vm.deleteFile(file, fileList, "pci")
                                },
                                limit: 10,
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-plus",
                                attrs: { slot: "trigger" },
                                slot: "trigger",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticStyle: { color: "red" } }, [
                        _vm._v(" 注销不可恢复，请谨慎操作； "),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.centerDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.tianku } },
                    [_vm._v("确认")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }